import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FunctionLifeCycle } from './telephonyutils';

export interface TelephonyEvent {
  type: string;
  name: string;
  data: any;
}
export interface MessengerEvent {
  type: string;
  name: string;
  data: any;
}
export interface InsightEvent {
  type: string;
  name: string;
  data: any;
}
@Injectable({ providedIn: 'root' })
export abstract class MessagingProvider {
  events: Subject<MessengerEvent> = new Subject<MessengerEvent>();
  clientInitialized: boolean = false;
  abstract init(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): void;
  abstract setAllMessagesRead(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract sendMessage(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract typing(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract destroy(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract getParticipantByIdentity(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract sendTCPAMessage(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
}

@Injectable({ providedIn: 'root' })
export abstract class VoiceProvider {
  events: Subject<TelephonyEvent> = new Subject<TelephonyEvent>();
  abstract init(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): void;
  abstract makeCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract endCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract changeStatus(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract disposeCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract muteUnMuteCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract consultCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract conferenceCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract transferCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract endThirdPartyCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract toggleCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract holdCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract destroy(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract acceptCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract rejectCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract sendDTMF(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract outboundCallHangup(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract getQueuedCalls(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract monitorCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract stopMonitorCall(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract callMonitorOperation(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract sync(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract setOutboundCallSid(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract closeExistingConnections(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract reconnectVoice(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract forceDisposedAndLogout(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract reserveStatus(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract loadInsightSettings(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
}

@Injectable({ providedIn: 'root' })
export abstract class InsightProvider {
  events: Subject<InsightEvent> = new Subject<InsightEvent>();
  abstract init(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): void;
  abstract clientStats(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
  abstract forceLogOff(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): any;
}

@Injectable({ providedIn: 'root' })
export abstract class TelephonyProvider {
  constructor() {}
  abstract name(): string;
  abstract init(lifecyle?: FunctionLifeCycle | null | undefined, ...args: any[]): void;
  abstract get messaging(): MessagingProvider;
  abstract get voice(): VoiceProvider;
  abstract get insight(): InsightProvider;
}
